import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { useSelector } from 'react-redux';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl, toBool } from '../../utils/Helper';
import Loader from '../../components/Loader/loader';
import { formatLocalTime } from '../../js/utility';
import CustomPressable from '../../components/customPressable/customPressable';
import moment from 'moment';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { isFirstReservation } from '../../Redux/Actions/reservationAction';
import InfoPopupModal from '../../components/infoPopupModal';



const MyReservations = (props) => {
    const { myReservations=[], isFetchingMyReservation, cancelAppointmentId, setCancelAppointmentId, selectedEvent={}, handleDeleteReservation, handleNext, handleGoBack } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const { serverTimeDataObj } = useSelector(state => state.serverDateTimeSlice);
    const serverDateTime = new Date(serverTimeDataObj.date);
    const TIME_FORMAT = useSelector(state => state.deviceConfigSlice?.extraConfigParam?.TIME_FORMAT_MERIDIEM) || false;

    const { currentWidget, extraConfigParam } = useSelector(state => state.deviceConfigSlice);
    const dateFormat = extraConfigParam?.DATE_FORMAT;

    

    const filterEvent = (data) => {
        const id = selectedEvent.eventId;
        if(!data) return data;
        return data.filter((d) => d.event.event_id == id);
    }

    const formatDate = (dateString) => {
        // console.log(dateString, "dateString");
        const date = new Date(dateString);
        const today = serverTimeDataObj?.date
            ? new Date(serverTimeDataObj.date.split("T")[0])
            : new Date();

        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
        const diffInTime = date.getTime() - today.getTime();
        const diffInDays = diffInTime / oneDayInMilliseconds;

        if (diffInDays === 0) {
            return "Today";
        } else if (diffInDays === -1) {
            return "Yesterday";
        } else if (diffInDays === 1) {
            return "Tomorrow";
        } else {
            return `${moment(new Date(dateString)).format(dateFormat.toUpperCase())}`

        }
    };

    const groupingByDate = (data) => {
        const groupedAccToDay = new Map();

        data.sort((a, b) => {
            return (
                new Date(a.real_datetime_of_slot).getTime() -
                new Date(b.real_datetime_of_slot).getTime()
            );
        });
        // console.log(data);
        data.forEach((d) => {
            const groupingKey = formatDate(d.date);
            if (groupedAccToDay.has(groupingKey)) {
                const keyData = groupedAccToDay.get(groupingKey);
                keyData.push(d);
            } else {
                groupedAccToDay.set(groupingKey, [d]);
            }
        });

        console.log(groupedAccToDay, "groupedAccToDay");
        return groupedAccToDay;
    };
    

    const renderHeader = () => <View style={getStyles(['widgetmainContainerHeaderContainer', 'reservationsHeaderContainer'])}>
        {
            currentWidget?.widgetHeaderImageUrl &&
            <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'reservationsHeaderImg'])} />
        }
        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'reservationsHeaderTitleContainer'])}>
            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'reservationsHeaderTitle'])}>{selectedEvent.eventName}</Text>
            <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'reservationsHeaderSubTitle'])}>{t('events.subtitle2')}</Text>
        </View>
    </View>

    return (
        <View style={getStyles(['widgetRootContainer', 'reservationsRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
                        
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'reservationsMainContainer'])} 
                showsVerticalScrollIndicator={false}
            >
                {renderHeader()}

                {isFetchingMyReservation ? <Loader /> : <View style={getStyles(['widgetmainContainerChildContainer', 'reservationsMainContainerChildContainer'])}>
                    {filterEvent(myReservations)?.length > 0
                        ? <>
                            {Array.from(groupingByDate(filterEvent(myReservations)).entries()).map(([day, dataOnThatDay]) => {
                            return (
                                <View style={getStyles(["list_itemContainer", "reservationsListContainer"])} id='list_itemContainer reservationsListContainer'>
                                    <Text style={getStyles(["list_itemContainer_textContainer_title", "reservationsListContainerTitle"])} id='list_itemContainer_textContainer_title reservationsListContainerTitle'>{day}</Text>
                                    {dataOnThatDay.map((reservation) => {
                                        return (
                                            <View style={getStyles(["list_itemContainer_textContainer_subtitle", "reservationsListDesciptionContainer", `reservationsListDesciptionContainer_${reservation.event.inventory_id}`])}>
                                                <View style={getStyles(["reservationsListDesciptionContainerTextContainer"])} id='reservationsListDesciptionContainerTextContainer'>
                                                    <Text style={getStyles(["reservationsListDesciptionContainerTextTitle"])} id='reservationsListDesciptionContainerTextTitle'>{getNameOfInventory(selectedEvent.events, reservation.venue_id, reservation.event.inventory_id)}</Text>

                                                    <Text style={getStyles(["reservationsListDesciptionContainerTextSubtitle"])} id='reservationsListDesciptionContainerTextSubtitle'>
                                                        {formatLocalTime(new Date(reservation.real_datetime_of_slot), toBool(TIME_FORMAT))}
                                                    </Text> 
                                                </View>




                                                <View style={getStyles(["reservationsListDesciptionContainerStatusContainer"])} id='reservationsListDesciptionContainerStatusContainer'>
                                                    {reservation.status != "NOT_RECONCILED" ? (reservation.status != "CANCELED" ?
                                                            <Text style={getStyles(["reservationsListDesciptionContainerStatusText"])}>
                                                                {reservation?.status?.replace("_"," ")}
                                                            </Text>
                                                        :   <Text style={getStyles(["reservationsListDesciptionContainerStatusText"])}>
                                                                {'cancelled'}
                                                            </Text>)
                                                        : (
                                                        <>

                                                            <CustomPressable
                                                                style={getStyles(["reservationsListDesciptionContainerCancel"])}
                                                                id="reservationsListDesciptionContainerCancel"
                                                                onPress={() => {
                                                                    // console.log("apponitmentId for cancellationg", reservation.id)
                                                                    setCancelAppointmentId(reservation.id);
                                                                }}
                                                            >
                                                                {/* <i className="fas fa-times"></i> */}
                                                                <Text style={getStyles(["reservationsListDesciptionContainerCancelTxt"])} id='reservationsListDesciptionContainerCancelTxt'>Cancel</Text>
                                                            </CustomPressable>
                                                        </>
                                                    )}
                                                </View>
                                            </View>
                                        );
                                    })}
                                </View>
                            );
                        })}
                    </>
                    : 
                    <View style={getStyles(["reservationsNoReservationErrorContainer"])} id='reservationsNoReservationErrorContainer'>
                        <Text style={getStyles(["reservationsNoReservationError"])} id='reservationsNoReservationError'>{t("events.no_reservation")}</Text>
                    </View>}
                </View>}
            </ScrollView>

            <View id='reservationsNextButtonContainer' style={getStyles(['reservationsNextButtonContainer'])}>
                <CustomPressable style={getStyles(["primaryBtn"])} disabled={!(isFirstReservation() || (myReservations?.length>0))} onPress={()=> handleNext()} id="primaryBtn">
                    <Text style={getStyles(["primaryBtnTxt"])} id='primaryBtnTxt'>
                        {t("events.make_a_reservation")}
                    </Text>
                </CustomPressable>
                {/* <CustomPressable style={getStyles(["secondaryBtn"])} onPress={()=> handleGoBack()} id="secondaryBtn">
                    <Text style={getStyles(["secondaryBtnTxt"])} id='secondaryBtnTxt'>
                        {t("spaBooking.back")}
                    </Text>
                </CustomPressable> */}
            </View>

            {cancelAppointmentId && <InfoPopupModal
                title={t('check_in.cancel_heading')}
                subtitle={t('check_in.cancel_subheading')}
                onClose={() => setCancelAppointmentId(null)}
                secondaryBtnLabel={"No"}
                OnRequestClose={() => setCancelAppointmentId(null)}
                onContinue={() => handleDeleteReservation(cancelAppointmentId)}
                primaryBtnLabel={"Yes"}
            />}

        </View>
    )
}

const getNameOfInventory = (events,venueId,inventoryId) => {
    let inventory_name = "";
    events.forEach((e)=>{
        if(e.venueId==venueId){
            for(const inventory of e.inventories){
                if(inventory.id==inventoryId){
                    inventory_name=inventory.inventory_name;
                     break;
                }
            }
        }
         
    })
    return inventory_name;
}

export default MyReservations
